import React, { Component } from 'react';

import style from './AnalyticsInfoBlock.module.scss';

interface Props {
  title: string;
  value: string;
  valueColor?: string;
}

class AnalyticsInfoBlock extends Component<Props> {
  render() {
    const { title, value, valueColor } = this.props;

    return (
      <div className={style.container}>
        <div className={style.title}>{title}</div>
        <div className={style.value} style={{ color: valueColor }}>
          {value}
        </div>
      </div>
    );
  }
}

export default AnalyticsInfoBlock;
